import { keyboardNavigation } from "../shared/keyboard";
import { mouseNavigation } from "../shared/mouse";
import {
    condensedMobileNavigationBar,
    expandMobileEditionMenu,
    expandMobileSidebarMenu,
    toggleMobileSubMenuLogo,
} from "../shared/mobile";
import {
    condensedStateDesktopLogo,
    secondaryMenuDropdown,
    updateSubNavItemStyles,
    updatePrimaryNavDropdownPosition,
    updateTickerNavDropdownPosition,
    updateSecondaryNavDropdownPosition,
    nbaTickerHoverHandler,
    overflowDetector,
    enableDesktopClickDropdownsOnNoHover,
    enableClickEllipsisDropdownSubnav,
} from "../shared/desktop";

import { setEditionItemsWidth } from "../../furniture/_edition";

const runNavigationHandlers = () => {
    const navigation = document.querySelector("#mainNavigation");
    if (!navigation) {
        return;
    }

    expandMobileSidebarMenu();
    expandMobileEditionMenu();
    toggleMobileSubMenuLogo();
    condensedMobileNavigationBar();

    keyboardNavigation();
    mouseNavigation();
    condensedStateDesktopLogo();
    secondaryMenuDropdown();
    updateSubNavItemStyles();
    updatePrimaryNavDropdownPosition();
    updateTickerNavDropdownPosition();
    updateSecondaryNavDropdownPosition();
    nbaTickerHoverHandler();
    overflowDetector();
    enableDesktopClickDropdownsOnNoHover();
    setEditionItemsWidth();
    enableClickEllipsisDropdownSubnav();
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runNavigationHandlers);
} else {
    runNavigationHandlers();
}

window.addEventListener("resize", () => {
    setEditionItemsWidth();
});
